module.exports = __webpack_public_path__ + "img/94030.6ad839fe.svg";